var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#8962D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75001 8.443C7.75001 6.67956 9.2051 5.25 11 5.25C12.795 5.25 14.2501 6.67956 14.2501 8.443C14.2501 10.2064 12.795 11.636 11 11.636C9.2051 11.636 7.75001 10.2064 7.75001 8.443ZM13.2501 8.443C13.2501 7.22216 12.2427 6.23246 11 6.23246C9.75739 6.23246 8.75003 7.22216 8.75003 8.443C8.75003 9.66385 9.75739 10.6535 11 10.6535C12.2427 10.6535 13.2501 9.66385 13.2501 8.443Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24546 12.4506C9.64643 11.5416 11.4181 11.3838 12.9627 12.0303C13.2167 12.1367 13.3349 12.4252 13.2267 12.6748C13.1185 12.9244 12.8248 13.0405 12.5707 12.9342C11.3349 12.4169 9.91744 12.5432 8.79656 13.2704C7.67567 13.9977 7.00092 15.2289 7.00001 16.5487C6.99982 16.82 6.77581 17.0397 6.49966 17.0395C6.22352 17.0394 5.99981 16.8193 6 16.548C6.00114 14.8985 6.8445 13.3596 8.24546 12.4506Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 14.0332L17.7032 13.8339C18.2754 13.2718 19.0876 13.0143 19.8863 13.1417C20.6297 13.2604 21.2793 13.6998 21.6653 14.3516L21.7341 14.4771C22.2181 15.4289 22.0285 16.5782 21.2704 17.3238L17.8611 20.8181C17.6642 21.0198 17.336 21.0198 17.1392 20.8181L13.6418 17.2323C12.996 16.5241 12.8194 15.5098 13.2015 14.6136L13.2655 14.4771C13.6273 13.766 14.315 13.2692 15.1137 13.1417C15.9123 13.0143 16.7247 13.2718 17.2969 13.8338L17.5001 14.0332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.d5459009c9ba43e07c3d0a3ec7e66846.svg";
export { ForwardRef as ReactComponent };